var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.9999 9.33325V13.9999M13.9999 18.6666H14.0116M12.0049 3.33658L2.12324 19.8332C1.9195 20.1861 1.8117 20.5861 1.81056 20.9935C1.80942 21.4009 1.91497 21.8016 2.11673 22.1555C2.31849 22.5095 2.60942 22.8045 2.96056 23.0111C3.31171 23.2177 3.71083 23.3288 4.11824 23.3332H23.8816C24.289 23.3288 24.6881 23.2177 25.0392 23.0111C25.3904 22.8045 25.6813 22.5095 25.8831 22.1555C26.0848 21.8016 26.1904 21.4009 26.1892 20.9935C26.1881 20.5861 26.0803 20.1861 25.8766 19.8332L15.9949 3.33658C15.7869 2.9937 15.4941 2.71022 15.1446 2.51348C14.7952 2.31674 14.4009 2.21338 13.9999 2.21338C13.5989 2.21338 13.2046 2.31674 12.8552 2.51348C12.5057 2.71022 12.2129 2.9937 12.0049 3.33658Z",
    stroke: "#DC6803",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.5eb184edc719d605dd706275178d1e50.svg";
export { ForwardRef as ReactComponent };